import {doSchemaCreate} from "../../actions/thunks/schemaThunks";
import {getAccessToken} from "../storage/accessTokenStorage";

const dispatchSchemaCreate = (component, endpoint, payload, callback) => {
  let creationEndpoint = endpoint || component.props.requestEndpoint;
  let accessToken = component.props.accessToken || getAccessToken();
  component.props.dispatch(doSchemaCreate(accessToken, creationEndpoint, true, payload, callback))
};

export default dispatchSchemaCreate;